import cx from 'classnames'

interface IRichTextPreviewProps {
  content?: string | undefined
  className?: string
}

const RichTextPreview = ({ content, className }: IRichTextPreviewProps) => {
  if (!content) return null

  // eslint-disable-next-line react/no-danger
  return <div className={cx('rich-text-preview', className)} dangerouslySetInnerHTML={{ __html: content }} />
}

export default RichTextPreview
